import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axios.instance";
import axios from "axios";
import { API_ADD_CAMPAIGN, API_GET_IMAGE_CONFIG ,API_ADD_TRIAL_CAMPAIGN} from "../../api/campaign.service";
import { blob } from "../../utils/templateUtils";
import { API_START_CONVERSATION } from "../../api/template.service";
import { API_POST_WABAID } from "../../api/chat.service";
const shareBroadcast = createAsyncThunk(
  "messageShare/sharebroadcast",
  async ({ configData, media, schedule=false}, thunkAPI) => {
    try {
      var config={...configData};
      if (media) {
        let img = await blob(media).then(blobFile => new File([blobFile], `file.${blobFile.type.split('/')[1]}`, { type: blobFile.type }))
        const { src, url } = await API_GET_IMAGE_CONFIG({
          imageType: "broadcast",
        });
        
        await axios.put(src, img,{
          headers: { "Content-Type": img.type },
        })  
        config={
          ...config,
          variables:{
            ...config.variables,
            mediaUrl:url
          }
        }

      }
      const {data}  = await API_ADD_CAMPAIGN(config,schedule);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const startConversation = createAsyncThunk(
  "messageShare/startconversation",
  async ({ config, media}, thunkAPI) => {
    try {
        if (media) {
        const { src, url } = await API_GET_IMAGE_CONFIG({imageType: "broadcast" });
        await axios.put(src, media,{ headers: { "Content-Type":" image/png" }}) ;
        config={
          ...config,
          variables:{
            ...config.variables,
           "{{mediaUrl}}":url,
          }
        }
      }
      const {data}  = await API_START_CONVERSATION(config);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
const shareTrialBroadcast = createAsyncThunk(
  "messageShare/shareTrialBroadcast",
  async ({ configData, media ,schedule=false }, thunkAPI) => {
    try {
      let config = { ...configData };
      
      if (media) {
        let img = await blob(media).then(blobFile => new File([blobFile], `file.${blobFile.type.split('/')[1]}`, { type: blobFile.type }));

        const { src, url } = await API_GET_IMAGE_CONFIG({
          imageType: "broadcast",
        });

        await axios.put(src, img, {
          headers: { "Content-Type": img.type },
        });

        config = {
          ...config,
          variables: {
            ...config.variables,
            mediaUrl: url,
          },
        };
      }

      const {data}  = await API_ADD_TRIAL_CAMPAIGN(config,schedule);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const updateWabaid = createAsyncThunk(
  "messageShare/updateWabai",
  async ({ config}, thunkAPI) => {
    try {
      const {data}  = await API_POST_WABAID(config);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export { shareBroadcast ,startConversation,updateWabaid,shareTrialBroadcast};
